<template>
    <div class="separator"></div>
</template>

<script>
    export default {
        name: 'separator'
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .separator {
        display: block;
        clear: both;
        position: relative;

        &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: .5px;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(255, 255, 255, .5);
        }
    }
</style>



// WEBPACK FOOTER //
// node_modules/@bistudio/bohemia-vue-components-old/src/components/partials/Separator.vue